module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row div-spacing-top"
  }, [(_vm.isLoadingAddress) ? _c('loading-component') : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.Order.IsExamOnly) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters order-div"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [(!_vm.Order.ShippingUseDifferent && !_vm.$route.params.code) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [(_vm.Account.accountType != '1') ? _c('span', {
    staticClass: "font-order"
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.legalName))]) : _c('span', {
    staticClass: "font-order"
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.firstName) + " " + _vm._s(_vm.Account.primaryContact.lastName))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-order"
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.streetAddress) + " " + _vm._s(_vm.Account.primaryContact.officeLocation.suite))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-order"
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.city) + ", " + _vm._s(_vm.Account.primaryContact.officeLocation.state) + " " + _vm._s(_vm.Account.primaryContact.officeLocation.zip))]), _c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.Order.ShippingUseDifferent && _vm.$route.params.code) ? _c('div', [_c('span', {
    staticClass: "font-order"
  }, [_vm._v(_vm._s(_vm.Order.ShippingFullName))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-order"
  }, [_vm._v(_vm._s(_vm.Order.ShippingAddressLineOne))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-order"
  }, [_vm._v(_vm._s(_vm.Order.ShippingAddressLineTwo))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-order"
  }, [_vm._v(_vm._s(_vm.Order.ShippingCity) + ", " + _vm._s(_vm.Order.ShippingState) + " " + _vm._s(_vm.Order.ShippingPostcode))]), _c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.ShippingUseDifferent),
      expression: "Order.ShippingUseDifferent"
    }],
    staticClass: "form-check-input",
    attrs: {
      "disabled": _vm.Order.RemakeRedoReason === 'OTH-LABREDO',
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Order.ShippingUseDifferent) ? _vm._i(_vm.Order.ShippingUseDifferent, null) > -1 : (_vm.Order.ShippingUseDifferent)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Order.ShippingUseDifferent,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Order, "ShippingUseDifferent", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Order, "ShippingUseDifferent", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Order, "ShippingUseDifferent", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-check-label g-font-size-18"
  }, [_vm._v("Use a different shipping address for this order")])])]), _vm._v(" "), (_vm.Order.ShippingUseDifferent && _vm.MasterAccountType != 'master') ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Location Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.ShippingFullName),
      expression: "Order.ShippingFullName"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderShippingFullName
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.ShippingFullName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "ShippingFullName", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.ValidationResult.OrderShippingFullName) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderShippingFullName))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.Order.ShippingUseDifferent) ? _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Street Address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.ShippingAddressLineOne),
      expression: "Order.ShippingAddressLineOne"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderShippingAddressLineOne
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.ShippingAddressLineOne)
    },
    on: {
      "change": _vm.addressChanged,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "ShippingAddressLineOne", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderShippingAddressLineOne) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderShippingAddressLineOne))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.Order.ShippingUseDifferent) ? _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Suite")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.ShippingSuite),
      expression: "Order.ShippingSuite"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.ShippingSuite)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "ShippingSuite", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.Order.ShippingUseDifferent) ? _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.ShippingCity),
      expression: "Order.ShippingCity"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderShippingCity
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.ShippingCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "ShippingCity", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderShippingCity) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderShippingCity))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.Order.ShippingUseDifferent) ? _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.ShippingState),
      expression: "Order.ShippingState"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderShippingState
    },
    staticStyle: {
      "height": "36.5px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Order, "ShippingState", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.State), function(value, key) {
    return _c('option', {
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(value))])
  }), 0), _vm._v(" "), (_vm.ValidationResult.OrderShippingState) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderShippingState))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.Order.ShippingUseDifferent) ? _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [(_vm.Order.ShippingUseDifferent) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Zip*")]), _vm._v(" "), (_vm.isValidAddress) ? _c('span', [_c('i', {
    staticClass: "fa fa-check-circle check_icon"
  })]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.ShippingPostCode),
      expression: "Order.ShippingPostCode"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderShippingPostCode
    },
    attrs: {
      "maxlength": "5",
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.ShippingPostCode)
    },
    on: {
      "keypress": function($event) {
        return _vm.G_NumberCheck(this.event)
      },
      "blur": function($event) {
        return _vm.ValidateAddress()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "ShippingPostCode", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderShippingPostCode) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderShippingPostCode))]) : _vm._e()]) : _vm._e()]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.MasterAccountType == 'master') ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group order-div"
  }, [_c('label', [_vm._v("Assigned Lab")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "deselectLabel": " ",
      "label": "name",
      "options": _vm.labList,
      "selectedLabel": " ",
      "placeholder": " ",
      "selectLabel": " "
    },
    model: {
      value: (_vm.Order.OrderLab),
      callback: function($$v) {
        _vm.$set(_vm.Order, "OrderLab", $$v)
      },
      expression: "Order.OrderLab"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No elements found.")])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.MasterAccountType == 'master') ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters order-div"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Special Instructions For Lab")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.SpecialLabInstructions),
      expression: "Order.SpecialLabInstructions"
    }],
    staticClass: "form-control",
    attrs: {
      "row": "3"
    },
    domProps: {
      "value": (_vm.Order.SpecialLabInstructions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "SpecialLabInstructions", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.Order.ShowExtraStudentFields == true) ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group center order-div"
  }, [_c('label', [_vm._v("Manifest Distance Acuity")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("RE/OD")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.ReManifestAcuity),
      expression: "Order.ReManifestAcuity"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "20/"
    },
    domProps: {
      "value": (_vm.Order.ReManifestAcuity)
    },
    on: {
      "keyup": function($event) {
        return _vm.acuityPrefixR()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "ReManifestAcuity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("LE/OS")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.LeManifestAcuity),
      expression: "Order.LeManifestAcuity"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "20/"
    },
    domProps: {
      "value": (_vm.Order.LeManifestAcuity)
    },
    on: {
      "keyup": function($event) {
        return _vm.acuityPrefixL()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "LeManifestAcuity", $event.target.value)
      }
    }
  })])])])])]) : _vm._e(), _vm._v(" "), ((!_vm.Order.IsExamOnly && _vm.Order.ShowExtraStudentFields == true)) ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group center order-div"
  }, [_c('label', [_vm._v("Wearing Instructions")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Patient should wear glasses:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.PatWearingInstructions),
      expression: "Order.PatWearingInstructions"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "36.5px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Order, "PatWearingInstructions", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "FullTime"
    }
  }, [_vm._v("Full-time")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Distance"
    }
  }, [_vm._v("For distance only")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Near"
    }
  }, [_vm._v("For near vision only")])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters order-div"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Patient/Order Notes (not sent to lab)")]), _vm._v(" "), _c('p', [_vm._v("This information is for your internal use only and will not be shared with the laboratory")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.DispenserNotes),
      expression: "Order.DispenserNotes"
    }],
    staticClass: "form-control",
    attrs: {
      "row": "3"
    },
    domProps: {
      "value": (_vm.Order.DispenserNotes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "DispenserNotes", $event.target.value)
      }
    }
  })])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n            Additional Information\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12"
  }, [_c('p', [_vm._v("Shipping Address:\n                    "), _c('span', {
    attrs: {
      "data-balloon": "This is the default shipping address for this account. To edit this address, go to the “My Account” page.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-05e9baf8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05e9baf8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/Order/OrderComponent/AdditionalInformation.vue
// module id = 460
// module chunks = 3